<template>
  <div id="app">
    <div class="header">
      <div class="wrap">
        <div class="logo flt">
          <a href="http://www.distinctclinic.com/index.php">
            <img src="./assets/distinct_logo.png">
          </a>
        </div>
        <div class="frt">
          <div class="flt linkBlock">
            <a
              class="toHomeUrl"
              href="http://www.distinctclinic.com/institution/institution_city.html"
            >机构网络</a>
            <a class="toHomeUrl" href="http://www.distinctclinic.com/doctors/doctors_list.html">医生团队</a>
            <a class="toHomeUrl" href="http://www.distinctclinic.com/service/serve_list.html">服务内容</a>
            <a class="toHomeUrl" href="https://app.distinctclinic.com/news/index.html#/">医学科普</a>
            <a class="toHomeUrl" href="http://www.distinctclinic.com/join/join.html">加入卓正</a>
            <a class="toHomeUrl" href="http://www.distinctclinic.com/about/aboutUs.html">关于卓正</a>
          </div>
          <div class="lang_select flt tel">
            <img
              src="./assets/cn_icon.png"
              v-if="selectedLangue == 1"
              alt=""
              style="vertical-align:-3px;padding-right:5px;"
            >
            <img
              src="./assets/en_icon.png"
              v-if="selectedLangue == 2"
              alt=""
              style="vertical-align:-3px;padding-right:5px;"
            >
            <select class="tel" v-model="selectedLangue" @change="selectLangue">
              <option value="1">中文</option>
              <option value="2">English</option>
              <option value="3">日本语</option>
            </select>
          </div>
          <!--<div class="tel flt" style="font-size:88%;">400 822 0909</div>-->
        </div>
        <div class="wap_menu"></div>
        <div class="clear"></div>
      </div>
    </div>
    <router-view/>
    <div class="footer">
      <div class="wrap">
        <div class="foot_lt flt">
          <span>
            <img src="./assets/icon1.png">
            <label>
              <img src="./assets/ewm.jpg">
            </label>
          </span>
          <span>
            <img src="./assets/icon2.png">
            <label>
              <img src="./assets/AppQrcode.png">
            </label>
          </span>
          <span>
            <img src="./assets/icon3.png">
            <label>
              <img src="./assets/waitForQrcode.png">
            </label>
          </span>
        </div>
        <div class="foot_rt frt">
          <img
            src="./assets/tel_icon.png"
            style="vertical-align:-3px;"
          >400 822 0909 &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; Copyright © 2012-2014 卓正医疗版权所有 粤ICP备13040663号
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      selectedLangue: '1'
    }
  },
  methods: {
    selectLangue: function(e) {
      if (this.selectedLangue == 1) {
        window.open('http://www.distinctclinic.com/')
      } else if (this.selectedLangue == 2) {
        window.open('http://www.distinctclinic.com/en/page/home.html')
      } else if (this.selectedLangue == 3) {
        window.open('http://www.distinctclinic.com/jp/page/home.html')
      }
    }
  }
}
</script>

<style>
/*----------common----------*/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
font,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
}
input,
select,
textarea {
  -webkit-appearance: none;
  font-family: 'Microsoft YaHei', 'Open Sans', sans-serif;
  font-size: 0.88em;
}
select {
  border: none;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: url('./assets/arrow.png') no-repeat scroll right center
    transparent;
  padding-right: 14px;
  outline: none;
}
img {
  max-width: 100%;
}
img,
a {
  border: 0;
}
.wrap {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  font-family: 'Microsoft YaHei', 'Open Sans', sans-serif;
}
.flt {
  float: left;
}
.frt {
  float: right;
}
.clear {
  clear: both;
}

/*----------header----------*/
.header {
  padding: 20px 0 14px;
  border-bottom: 1px solid #e8e8e8;
}
.header .frt {
  color: #757575;
  line-height: 27px;
}
.header .frt {
  color: #757575;
  line-height: 27px;
  padding-top: 6px;
}
.lang_select select {
  color: #757575;
}
.lang_select {
  margin-left: 35px;
}

/*----------footer----------*/
.footer {
  padding-top: 30px;
  width: 100%;
  border-top: 1px solid #e6e6e6;
  background: #fff;
  text-align: right;
}
.foot .wrap {
  line-height: 45px;
  border-top: 1px solid #e6e6e6;
  margin-top: 20px;
  text-align: left;
}
.foot_lt span {
  display: inline-block;
  position: relative;
  margin-left: 40px;
  cursor: pointer;
}
.foot_lt span:hover label {
  display: block;
}
.foot_lt span label {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
  position: absolute;
  margin-bottom: 10px;
  display: none;
  bottom: 80%;
  left: 70%;
  margin-left: -50px;
  width: 98px;
}
.foot_lt img {
  display: block;
}
.foot_rt {
  line-height: 20px;
  padding: 15px 0;
  text-align: center;
  font-size: 12px;
}
.linkBlock {
  text-align: center;
}
.linkBlock a {
  /* color: #3a3a3a; */
  display: inline-block;
  padding-bottom: 5px;
  font-size: 1rem;
  text-decoration: none;
  margin: 0 16px;
}
.toHomeUrl {
  border-bottom: 4px solid #fff;
  color: #333;
  font-weight: 500;
  font-size: 1rem;
}
.toHomeUrl:hover {
  color: #006d82;
  border-bottom: 4px solid #006d83;
}

@media screen and (max-width: 1080px) {
  .wrap {
    max-width: 1000px;
  }
}
@media only screen and (max-width: 750px) {
  .tel {
    display: none;
  }
  .flt {
    float: none!important;
  }
  .flex-between{
    justify-content: center!important;
    display: flex;
    flex-direction: column!important;
  }
  .subCategoryShow{
    display: none!important;
  }
  .searchText{
    min-width: 60vw!important;
    max-width: 80vw!important;
  }
  .subCategoryTreeBlockShow{
    height: auto!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue